<template lang="pug">
v-dialog(v-model='visible' width='500px')
    v-card
        v-card-title(:class='themeColorClass') 
            v-icon.mr-2(v-if='titleIcon' color='red') {{ titleIcon }}
            | {{ title }}
        v-card-text.pa-4
            | {{ descriptionOfActionToBePerformed }}
            .mt-2.font-weight-bold.text-uppercase {{ boldAlert }}
            v-card-actions
                v-spacer 
                ButtonExit(@click='cancelled') Cancel
                v-btn(:class='themeColorClass' @click='confirmed' variant='outlined') {{ confirmLabel }}
    template(v-slot:activator='{ props }')
        slot(name='activator' v-bind='props')
            BaseListWrapper(density='compact')
                v-list-item(v-bind='props' :disabled='disabled')
                    template(v-slot:prepend)
                        v-icon(:color='iconColor' :block='iconButtonBlockStyle') {{ buttonIcon }}
                    v-list-item-title {{ label }}
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import IconButton from '@/common/IconButton.vue';
import BaseListWrapper from '@/common/BaseListWrapper.vue';
import ButtonExit from '@/common/button-components/ButtonExit.vue';

export default defineComponent({
    name: 'ConfirmationDialog',
    components: {
        ButtonExit,
        IconButton,
        BaseListWrapper,
    },
    emits: ['confirmed'],
    props: {
        title: {
            type: String,
            default: 'Are you sure?',
        },
        titleIcon: {
            type: String,
            default: null,
        },
        confirmLabel: {
            type: String,
            default: 'Confirm',
        },
        boldAlert: {
            type: String,
            default: 'This action cannot be undone',
        },
        descriptionOfActionToBePerformed: {
            type: String,
            required: true,
        },
        buttonIcon: {
            type: String,
            default: 'mdi-content-copy',
        },
        // The color of the button and parts of the dialog.
        iconColor: {
            type: String,
            default: 'blue',
        },
        // Something like 'red', 'green' or 'blue'.  Will be prefixed with `bg-` to form a Vuetify class.
        themeColor: {
            type: String,
            default: 'blue',
        },
        dataCy: {
            type: String,
            default: undefined,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: undefined,
        },
        iconButtonBlockStyle: {
            type: Boolean,
            default: false,
        },
        triggerVisibility: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            visible: false,
        };
    },
    mounted() {
        this.visible = this.triggerVisibility;
    },
    computed: {
        themeColorClass() {
            return `bg-${this.themeColor}`;
        },
    },
    methods: {
        confirmed(): void {
            this.$emit('confirmed', this);
        },
        cancelled(): void {
            this.visible = false;
        },
    },
});
</script>
